import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import SectionHeading from '../HomePage/SectionHeading'

export default function ClientSuccess({ shouldHaveBg = true }) {
    const successStories = [
        {
            image: '1.webp',
            profit: 80000,
            purchase_price: 135000,
            construction: 30000,
            arv: 245000,
            deal_type: 'Rehab',
            address: 'Middletown, NY',
        },
        {
            image: '2.webp',
            profit: 150000,
            purchase_price: 300000,
            construction: 30000,
            arv: 480000,
            deal_type: 'Rehab',
            address: 'Fall River, MA',
        },
        {
            image: '3.webp',
            profit: 68500,
            purchase_price: 300000,
            construction: 26500,
            arv: 395000,
            deal_type: 'Rehab',
            address: 'Nashua, NH',
        },
        {
            image: '4.webp',
            profit: 70000,
            purchase_price: 140000,
            construction: 40000,
            arv: 250000,
            deal_type: 'Rehab',
            address: 'Franklin, NH',
        },
        {
            image: '5.webp',
            profit: 92198,
            purchase_price: 165000,
            construction: 67802,
            arv: 325000,
            deal_type: 'Rehab',
            address: 'Tilton, NH',
        },
        {
            image: '6.webp',
            profit: 90383,
            purchase_price: 200000,
            construction: 84617,
            arv: 375000,
            deal_type: 'Rehab',
            address: 'Derry, NH',
        },
        {
            image: '7.webp',
            profit: 65000,
            purchase_price: 385000,
            construction: 60000,
            arv: 510000,
            deal_type: 'Rehab',
            address: 'Portsmouth, NH',
        },
        {
            image: '8.webp',
            profit: 200000,
            purchase_price: 300000,
            construction: 90000,
            arv: 590000,
            deal_type: 'Rehab',
            address: 'Portsmouth, NH',
        },
        {
            image: '9.webp',
            profit: 105000,
            purchase_price: 245000,
            construction: 70000,
            arv: 420000,
            deal_type: 'Rehab',
            address: 'Derry, NH',
        },
        {
            image: '10.webp',
            profit: 105000,
            purchase_price: 105000,
            construction: 0,
            arv: 210000,
            deal_type: 'Rehab',
            address: 'Napanoch, NY',
        },
        {
            image: '11.webp',
            profit: 99800,
            purchase_price: 150000,
            construction: 100200,
            arv: 350000,
            deal_type: 'Rehab',
            address: 'Sutton, NH',
        },
        {
            image: '12.webp',
            profit: 23500,
            purchase_price: 165000,
            construction: 26500,
            arv: 215000,
            deal_type: 'Rehab',
            address: 'Rumney, NH',
        },
        {
            image: '13.webp',
            profit: 94300,
            purchase_price: 242000,
            construction: 83700,
            arv: 420000,
            deal_type: 'Rehab',
            address: 'Millville, MA',
        },
        {
            image: '14.webp',
            profit: 82750,
            purchase_price: 140000,
            construction: 62250,
            arv: 285000,
            deal_type: 'Rehab',
            address: 'N Jackson, FL',
        },
        {
            image: '15.webp',
            profit: 109000,
            purchase_price: 251000,
            construction: 43000,
            arv: 403000,
            deal_type: 'Rehab',
            address: 'Manchester, NH',
        },
        {
            image: '16.webp',
            profit: 116000,
            purchase_price: 200000,
            construction: 109000,
            arv: 425000,
            deal_type: 'Rehab',
            address: 'Hebron, NH',
        },
        {
            image: '17.webp',
            profit: 75700,
            purchase_price: 205000,
            construction: 79300,
            arv: 360000,
            deal_type: 'Rehab',
            address: 'Andover, NH',
        },
        {
            image: '18.webp',
            profit: 39500,
            purchase_price: 340000,
            construction: 70500,
            arv: 450000,
            deal_type: 'Rehab',
            address: 'Tewksbury, MA',
        },
        {
            image: '19.webp',
            profit: 126700,
            purchase_price: 420000,
            construction: 68300,
            arv: 615000,
            deal_type: 'Rehab',
            address: 'Milton, MA',
        },
        {
            image: '20.webp',
            profit: 70000,
            purchase_price: 210000,
            construction: 30000,
            arv: 310000,
            deal_type: 'AirBNB',
            address: 'Lees Summit, MO',
        },
        {
            image: '21.webp',
            profit: 179000,
            purchase_price: 203000,
            construction: 43000,
            arv: 425000,
            deal_type: 'Rehab',
            address: 'Delaware, OH',
        },
        {
            image: '22.webp',
            profit: 91500,
            purchase_price: 272500,
            construction: 35000,
            arv: 399000,
            deal_type: 'Rehab',
            address: 'Lees Summit, MO',
        },
        {
            image: '23.webp',
            profit: 47000,
            purchase_price: 180000,
            construction: 38000,
            arv: 265000,
            deal_type: 'Rehab',
            address: 'Reynoldsburg, OH',
        },
        {
            image: '24.webp',
            profit: 385000,
            purchase_price: 275000,
            construction: 40000,
            arv: 700000,
            deal_type: 'Rehab',
            address: 'San Diego, CA',
        },
        {
            image: '25.webp',
            profit: 61000,
            purchase_price: 235000,
            construction: 39000,
            arv: 335000,
            deal_type: 'Rehab',
            address: 'Lakeview, OH',
        },
    ]
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768, // Adjust this value based on your needs
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }
    function currencyString(num) {
        return num.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
    }
    return (
        <div
            className={`${
                shouldHaveBg && 'bg-light-yellow-gradient md:p-20 py-28'
            } md:rounded-8xl rounded-10xl`}>
            <div className="max-w-6xl m-auto">
                <div className="mx-[2rem] space-y-8">
                    <SectionHeading>
                        Client{' '}
                        <span className="olm-gradient-text">Success</span>{' '}
                        Stories
                    </SectionHeading>
                    <Slider {...settings}>
                        {successStories.map((story, index) => (
                            <div key={index} className="px-3 py-4">
                                <div className="flex flex-col overflow-hidden rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)]">
                                    <div
                                        className="md:h-[325px] h-[255px]"
                                        style={{
                                            backgroundImage: `url(/assets/success-stories/${story.image})`,
                                            backgroundPosition: 'center center',
                                            backgroundSize: 'cover',
                                        }}></div>
                                    <div className="bg-olm-gradient-t-to-b p-[1px] pt-0">
                                        <div className="text-left lg:p-8 p-6 space-y-4 bg-white tracking-[0.5px] rounded-b-[20px]">
                                            <div>
                                                <div className="heading-underline relative inline-block">
                                                    <h3 className="font-semibold text-[25px] leading-none relative">
                                                        {currencyString(
                                                            story.profit,
                                                        )}{' '}
                                                        profit
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="space-y-3">
                                                <div className="text-base font-medium space-y-1">
                                                    <p className="space-x-1">
                                                        <span className="font-bold">
                                                            Purchase Price:
                                                        </span>
                                                        <span>
                                                            {currencyString(
                                                                story.purchase_price,
                                                            )}
                                                        </span>
                                                    </p>
                                                    <p className="space-x-1">
                                                        <span className="font-bold">
                                                            Construction:
                                                        </span>
                                                        <span>
                                                            {currencyString(
                                                                story.construction,
                                                            )}
                                                        </span>
                                                    </p>
                                                    <p className="space-x-1">
                                                        <span className="font-bold">
                                                            ARV:
                                                        </span>
                                                        <span>
                                                            {currencyString(
                                                                story.arv,
                                                            )}
                                                        </span>
                                                        <span className="font-bold">
                                                            Deal Type:
                                                        </span>
                                                        <span>
                                                            {currencyString(
                                                                story.deal_type,
                                                            )}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="text-base font-medium">
                                                    <p className="space-x-1">
                                                        <span className="font-bold">
                                                            Address:
                                                        </span>
                                                        <span>
                                                            {currencyString(
                                                                story.address,
                                                            )}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    )
}
